export default "<p>choferes works!</p>\n"